import Alpine from "alpinejs";
import Glide from "@glidejs/glide";

window.Alpine = Alpine;
window.Glide = Glide;
/*

*/

Alpine.start();
